// @flow

import React, { Component } from 'react';

import type { Node } from 'react';

type HeaderProviderState = {|
  accountId?: string,
  email?: string,
  fullName?: string,
  hasTeamAccount: boolean,
  imageUrl?: string,
  isDeveloper?: boolean,
  isLoggedIn: boolean,
  isStaff?: boolean,
|};

type Props = {|
  ...HeaderProviderState,
  children: Node,
|};

const initialContextState = {
  accountId: undefined,
  email: undefined,
  fullName: undefined,
  hasTeamAccount: false,
  imageUrl: undefined,
  isDeveloper: false,
  isLoggedIn: false,
  isStaff: false,
};

export const HeaderContext = React.createContext(initialContextState);

class HeaderProvider extends Component<Props, HeaderProviderState> {
  state = initialContextState;

  static getDerivedStateFromProps(props: Props) {
    return {
      accountId: props.accountId,
      email: props.email,
      hasTeamAccount: props.hasTeamAccount,
      isDeveloper: props.isDeveloper,
      isLoggedIn: props.isLoggedIn,
      isStaff: props.isStaff,
      fullName: props.fullName,
      imageUrl: props.imageUrl,
    };
  }

  render() {
    return (
      <HeaderContext.Provider value={this.state}>
        {this.props.children}
      </HeaderContext.Provider>
    );
  }
}

export default HeaderProvider;
